module.exports = {
          srcSet: __webpack_public_path__ + "c475f6525697ed7f104785b9ef09fb54-430.png"+" 430w",
          images:[ {path: __webpack_public_path__ + "c475f6525697ed7f104785b9ef09fb54-430.png",width: 430,height: 605}],
          src: __webpack_public_path__ + "c475f6525697ed7f104785b9ef09fb54-430.png",
          toString:function(){return __webpack_public_path__ + "c475f6525697ed7f104785b9ef09fb54-430.png"},
          
          width: 430,
          height: 605
        }